/**
* @fileOverview queue.component.ts - Contains handling of queue management
* @author Jan Valentik
*/
var QueueType;
(function (QueueType) {
    QueueType[QueueType["MY_QUEUE"] = 'myqueue'] = "MY_QUEUE";
    QueueType[QueueType["TEAM_QUEUE"] = 'teamqueue'] = "TEAM_QUEUE";
    QueueType[QueueType["STANDART_REPORT"] = 'standardreport'] = "STANDART_REPORT";
    //GBT20 = 'gbt20',
    QueueType[QueueType["ERROR_QUEUE"] = 'errorqueue'] = "ERROR_QUEUE";
    QueueType[QueueType["UNASSIGNED_QUEUE"] = 'unassigned'] = "UNASSIGNED_QUEUE";
    QueueType[QueueType["MANUAL_REVIEW_QUEUE"] = 'manualReview'] = "MANUAL_REVIEW_QUEUE";
    QueueType[QueueType["WORK_ITEMS_QUEUE"] = 'workitems'] = "WORK_ITEMS_QUEUE";
    QueueType[QueueType["SET_ASIDE_QUEUE"] = 'setAside'] = "SET_ASIDE_QUEUE";
    QueueType[QueueType["GEO_SPM_QUEUE"] = 'geospm'] = "GEO_SPM_QUEUE";
})(QueueType || (QueueType = {}));
var tempthat = {};
var QueueController = (function () {
    function QueueController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $rootScope, topic, moment) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$rootScope = $rootScope;
        this.topic = topic;
        this.moment = moment;
        this.activeInactive = 'active';
        this.newSearch = 'Default';
        //private samplingPage: boolean;
        this.processing = true;
        this.selectedStates = [];
        this.currFilter = [];
        this.dtInstance = {};
        this.checkBoxModel = {};
        this.items = [];
        this.payFreqBase = ['WEEKLY', 'MONTHLY', 'QUARTERLY', 'Unknown'];
        this.waitForReport = false;
        this.oncePressed = false;
        this.queryId = this.$stateParams.id;
        this.socket.forward('queueservice.assign', this.$scope);
        this.$scope.$on('socket:queueservice.assign', function (event, data) {
            if (data.isAssingToYourself && data.successes.length > 0) {
                var items = {
                    message: "Do you want to open " + data.payload.opp + " opportunity? ",
                    okMessage: 'YES',
                    cancelMessage: 'NO',
                    dialogName: 'Opportunity assigned'
                };
                _this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
                    if (dResult.confirm) {
                        _this.moveToOpp(data.payload);
                    }
                });
            }
            _this.isSubmitting = false;
            _this.dtInstance.DataTable.ajax.reload(null, false);
        });
        this.isDownloading = false;
        this.filters = {};
        this.filterIots = [];
        this.filterImts = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterStatuses = [];
        this.filterSubStatuses = [];
        this.filterOwners = [];
        this.teams = [];
        this.filterTeams = [];
        this.vapFilter = undefined; //was false;
        this.verFilter = undefined;
        this.showFilterBtn = false;
        this.filterDetails();
        this.socket.forward('teamView.getTeams', this.$scope);
        this.$scope.$on('socket:teamView.getTeams', function (event, data) {
            if (data.id === 'getTeams') {
                _this.allTeams = [];
                _this.myTeams = data.personsTeams;
                for (var _i = 0, _a = data.allTeams; _i < _a.length; _i++) {
                    var team = _a[_i];
                    if (!_this.myTeams.includes(team)) {
                        _this.allTeams.push(team);
                    }
                }
            }
        });
        this.socket.forward('filters.getUserFilters', this.$scope);
        this.$scope.$on('socket:filters.getUserFilters', function (event, data) {
            _this.userFilters = data;
            _this.filtersExist = true;
        });
        this.socket.forward('filters.deleteProfiles', this.$scope);
        this.$scope.$on('socket:filters.deleteProfiles', function (event, data) {
            _this.userFilters = data;
            _this.allowed = false;
        });
        this.$rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
            tempthat['viewLoaded'] = true;
        });
        socket.forward('queue.setaside.get-report', $scope);
        this.$scope.$on('socket:queue.setaside.get-report', function (event, data) {
            _this.waitForReport = false;
            if (!data.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.file], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-Set-Aside-Report_" + d + ".csv");
                a.click();
            }
        });
        socket.forward('queue.setaside.setPaid', $scope);
        this.$scope.$on('socket:queue.setaside.setPaid', function (event, data) {
            _this.dtInstance.DataTable.ajax.reload(null, false);
            if (data.error) {
                return _this.notify.error(data.error);
            }
            else {
                return _this.notify.success('Updated successfully.');
            }
        });
    }
    QueueController.prototype.isAdminUser = function () {
        if (this.env.user.access.bpsoAdmin || this.env.user.access.nonBpsoAdmin) {
            return true;
        }
        else {
            return false;
        }
    };
    QueueController.prototype.$onInit = function () {
        var _this = this;
        this.queueLabel = this.$stateParams.id;
        this.signalWrongResponse = '';
        var that = this;
        this.dtColumns = this.buildColumnsByQueueLabel(this.queueLabel);
        // Matt @ 4th Feb 18...Took this out to see the impact... component loads twice upon an F5... not sure why - Ivan
        // stuck this workaround in to prevent it, but it results in the 'State not loaded properly' error...
        //if (tempthat['viewLoaded']) {
        this.USstates = this.settings.us_states;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'FetchSavedFilters',
                script: '/queueservice/filterprofiles',
                user: this.env.user
            }
        });
        this.isSubmitting = false;
        switch (this.$stateParams.id) {
            case 'myqueue':
                this.queueHelp = 'This queue contains all Disbursements owned by you.';
                this.queueLabel = 'My Queue';
                this.isTeamQueue = false;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: true,
                    dmtSubStats: true,
                    teams: false,
                    ver: true
                };
                break;
            case 'unassigned':
                this.queueHelp = 'This queue contains all Unassigned Disbursements whose status is \'Duplicate Opp Search\', \'Waiting Eligibility Decision\' or \'Waiting Order Validation\'. NOTE: If VAP filtering is enabled no North American Disbursements will be displayed, but the status will be extended to include \'Draft\' and \'Denied Participation\'';
                this.queueLabel = 'Unassigned Queue';
                this.showMassAsignment = true;
                this.isTeamQueue = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: false,
                    dmtSubStats: false,
                    teams: false,
                    ver: true
                };
                break;
            case 'manualReview':
                this.queueHelp = 'This queue contains all Disbursements that need manual review';
                this.queueLabel = 'Manual Review';
                this.showMassAsignment = true;
                this.isTeamQueue = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: false,
                    dmtSubStats: false,
                    teams: false,
                    ver: true
                };
                break;
            case 'errorqueue':
                this.queueHelp = 'This queue contains all Disbursements with one or more Unresolved Error.  Hover over the Details for a breakdown of the error types.';
                this.queueLabel = 'Validation Queue';
                this.showMassAsignment = true;
                this.isTeamQueue = false;
                this.filterToggles = {
                    countries: true,
                    errors: true,
                    sviStats: true,
                    dmtStats: false,
                    dmtSubStats: false,
                    teams: false,
                    ver: true,
                    goe: true
                };
                break;
            case 'workitems':
                this.queueHelp = 'This queue contains all Disbursements regardless of status.';
                this.queueLabel = 'Work Items Queue';
                this.isTeamQueue = false;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: true,
                    dmtSubStats: true,
                    teams: false,
                    ver: true
                };
                break;
            case 'teamqueue':
                this.queueHelp = 'This queue contains all Disbursements owned by you and those in the same Teams as you.';
                this.queueLabel = 'Teams\' Queue';
                this.isTeamQueue = true;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    sviStats: true,
                    dmtStats: true,
                    dmtSubStats: true,
                    teams: true,
                    ver: true
                };
                break;
            case 'setAside':
                this.queueHelp = 'This queue contains all the set aside buckets.';
                this.queueLabel = 'Set Aside Queue';
                this.isTeamQueue = false;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    frequency: true,
                    sviStats: false,
                    dmtStats: false,
                    dmtSubStats: false,
                    teams: false,
                    vap: false,
                    ver: false
                };
                break;
            case QueueType.GEO_SPM_QUEUE:
                this.queueHelp = 'This queue contains all Disbursements regardless of status.';
                this.queueLabel = 'GEO SPM Queue';
                this.isTeamQueue = false;
                this.showMassAsignment = false;
                this.filterToggles = {
                    countries: true,
                    dmtStats: false,
                    dmtSubStats: false,
                    sviStats: true,
                    teams: false,
                    ver: true
                };
                break;
            default:
                this.queueLabel = '';
        }
        //If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        this.applyLastFilter();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.checkBoxModel = {};
                if (that.queryId === 'setAside') {
                    _this.items = data.data;
                }
                else {
                    data.data.forEach(function (dmtRec) {
                        that.checkBoxModel[dmtRec.opp] = false;
                    });
                }
                return data.data;
            },
            url: '/api/queue',
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
            },
            error: function (xhr, errorMessage, thrown) {
                // Display message, when a error appears
                //console.log('error response:' , xhr, errorMessage, thrown);
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Queue data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                    items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b>';
                }
                items.message += '<b style="color:red">' + errorMessage + '/' + thrown + '</b><br><br>';
                items.message += 'This is usually a temporary problem. &nbsp;Please try again, but if the problem persists contact the DMT System Administrators';
                //that.Dialog.updateValidForm(undefined, items, 'fail-alert.html').then((dResult) => {
                that.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
                    that.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                $('#table_processing').hide();
            },
            complete: function (d) {
                //alert('response received');
            },
            data: function (d, callback, settings) {
                var searchCountries = that.processFilterFieldValues(that.filterCountries);
                var searchSviStat = that.processFilterFieldValues(that.filterSviStatuses);
                var searchDmtStat = that.processFilterFieldValues(that.filterStatuses);
                var searchSubStat = that.processFilterFieldValues(that.filterSubStatuses);
                var searchOwner = that.processFilterFieldValues(that.filterOwners);
                var searchTeam = '';
                if (that.filterTeams.length) {
                    for (var _i = 0, _a = that.filterTeams; _i < _a.length; _i++) {
                        var item = _a[_i];
                        searchTeam += item + '|';
                    }
                    searchTeam = searchTeam.substring(0, searchTeam.length - 1);
                    d.columns.push({
                        data: 'team', name: 'team', orderable: false,
                        search: { regex: true, value: searchTeam }, searchable: false
                    });
                }
                var colIndex = 0;
                for (var _b = 0, _c = d.columns; _b < _c.length; _b++) {
                    var col = _c[_b];
                    if (searchCountries !== '' && col.name === 'country') {
                        col.search.regex = true;
                        col.search.value = searchCountries;
                    }
                    else if (searchCountries !== '' && col.data === 'doc.docCountry') {
                        d.countryFilter = that.filterCountries;
                    }
                    else if (searchDmtStat !== '' && col.name === 'status') {
                        col.search.regex = true;
                        col.search.value = searchDmtStat;
                    }
                    else if (searchSubStat !== '' && col.name === 'substatus') {
                        col.search.regex = true;
                        col.search.value = searchSubStat;
                    }
                    else if (searchOwner !== '' && col.name === 'owner') {
                        col.search.regex = true;
                        col.search.value = searchOwner;
                    }
                    else if (searchSviStat !== '' && col.name === 'svistat') {
                        col.search.regex = true;
                        col.search.value = searchSviStat;
                    }
                    else if (searchTeam !== '' && col.name === 'team') {
                        col.search.regex = true;
                        col.search.value = searchTeam;
                    }
                    else if (angular.isUndefined(that.dtColumns[colIndex].searchable) &&
                        angular.isDefined(that.dtColumns[colIndex].columnSearch)) {
                        col.search.regex = true;
                        col.search.value = that.dtColumns[colIndex].columnSearch;
                    }
                    colIndex++;
                }
                d.usStates = that.selectedStates;
                d.iotFilter = that.filterIots;
                d.imtFilter = that.filterImts;
                d.queueType = that.queryId;
                d.vapFilter = that.vapFilter;
                d.verFilter = that.verFilter;
                d.errorFilter = that.filterErrors;
                d.goeFilter = that.goeFilter;
                d.activeInactive = that.activeInactive;
                d.users = [("" + that.env.user.email)];
                d.freq = that.filterPayFreq;
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [4, 'asc'])
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow)
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        that.searchHandler();
        //        } else {
        //           this.signalWrongResponse = 'State not loaded properly'
        //          this.dtOptions = this.DTOptionsBuilder.newOptions()
        //             .withOption('data', []);
        //    }
        function createdRow(row, data, dataIndex) {
            var OFFSET = 3;
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
            var createdOn = new Date(parseInt(data.created, 10));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                $(row).addClass('tblRow').css('color', 'red');
            }
            else if (angular.isDefined(data.criticalColor)) {
                // If critical colour property added, set accordingly - error queue only (for now)
                $(row).addClass('tblRow').css('color', data.criticalColor);
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    QueueController.prototype.processFilterFieldValues = function (filterValues) {
        return Array.isArray(filterValues) ? filterValues.map(function (f) { return ("\"" + f + "\""); }).join('|') : '';
    };
    QueueController.prototype.buildColumnsByQueueLabel = function (queueLabel) {
        switch (queueLabel) {
            case QueueType.ERROR_QUEUE:
                return this.buildColumns_Error();
            case QueueType.SET_ASIDE_QUEUE:
                return this.buildColumnsSetAside();
            case QueueType.GEO_SPM_QUEUE:
                return this.buildColumnsGeoSpm();
            default:
                return this.buildColumns();
        }
    };
    // on destroy of the component a interval will be closed
    QueueController.prototype.$onDestroy = function () {
        clearInterval(this.interval);
        clearTimeout(this.waitTimeout);
        this.topic.reloadCheck.id = '';
    };
    QueueController.prototype.searchHandler = function () {
        var _this = this;
        var counter = 1000;
        this.interval = setInterval(function () {
            if ($('#table_filter input').length > 0) {
                $('#table_filter input').unbind();
                $('#table_filter input').bind('keyup', function (e) {
                    _this.signalWrongResponse = '';
                    clearTimeout(_this.waitTimeout);
                    _this.waitTimeout = setTimeout(function () {
                        clearInterval(_this.interval);
                        $('#table').dataTable().fnFilter($('#table_filter input:first').val());
                    }, 1000);
                    if (e.keyCode == 13) {
                        clearTimeout(_this.waitTimeout);
                        $('#table').dataTable().fnFilter($('#table_filter input:first').val());
                    }
                });
                counter = 0;
            }
            if (--counter < 0) {
                clearInterval(_this.interval);
            }
        }, 500);
    };
    QueueController.prototype.applyLastFilter = function () {
        var _this = this;
        //If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        if (this.settings.up.lastFilter) {
            angular.forEach(this.settings.up.lastFilter, function (v, k) {
                _this[k] = v;
            });
            this.isFilterToggled = true;
        }
    };
    QueueController.prototype.expand = function () {
        var tr = $('.ibm-data-table tbody tr:hover');
        var row = this.dtInstance.DataTable.row(tr);
        if (row.child.isShown()) {
            var expIcon = $('.ibm-data-table tbody tr:hover span md-icon.expand');
            expIcon.removeClass('ng-hide');
            var colIcon = $('.ibm-data-table tbody tr:hover span md-icon.collapse');
            colIcon.addClass('ng-hide');
            row.child.hide();
        }
        else {
            this.collapseRows();
            var expIcon = $('.ibm-data-table tbody tr:hover span md-icon.expand');
            expIcon.addClass('ng-hide');
            var colIcon = $('.ibm-data-table tbody tr:hover span md-icon.collapse');
            colIcon.removeClass('ng-hide');
            row.child(this.format(row.data())).show();
        }
    };
    QueueController.prototype.collapseRows = function () {
        var rowsCount = this.dtInstance.DataTable.page.info().length;
        for (var i = 0; i < rowsCount; i++) {
            if (this.dtInstance.DataTable.row(i).child.isShown()) {
                this.dtInstance.DataTable.row(i).child.hide();
            }
        }
    };
    QueueController.prototype.fixQuotes = function (val) {
        return val.replace(/'/g, '');
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.format = function (d) {
        var el = angular.element;
        if (d.substatus !== 'Unassigned' && d.substatus !== 'Pending Incentive GOE Check' && d.substatus !== 'Pending Manual Review') {
            return this.$compile(el("\n                    <table cellpadding='5' cellspacing='0' border='0' style='padding-left:50px;'>\n                        <tr ng-if=\"!vm.isSubmitting\">\n                            <td style=\"background-color:transparent; border: 0px;\">\n                                <type-ahead opp='" + d.opp + "' bpname='" + this.fixQuotes(d.bp) + "' status='" + d.status + "' country='" + this.settings.getShortName(d.country) + "' reassign=\"true\"/>\n                            </td>\n                        </tr>\n                        <tr ng-if=\"vm.isSubmitting\">\n                            <td style=\"background-color:transparent; border: 0px;\">\n                                <span class='ibm-h1' ng-if=\"vm.isSubmitting\">\n                                    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n                                </span>\n                            </td>\n                        </tr>\n                    </table>").contents())(this.$scope);
        }
        else {
            return this.$compile(el("\n                    <table cellpadding='5' cellspacing='0' border='0' style='padding-left:50px;'>\n                        <tr ng-if=\"!vm.isSubmitting\">\n                            <td style=\"border: 0px;\">\n                                <md-button style=\"background-color: rgb(63,81,181); color: rgba(255,255,255,0.87);\" ng-click=\"vm.assign([{opp:'" + d.opp + "',bpname:'" + (d.bp ? d.bp.replace(/"/g, '') : 'Unknown BP') + "',status:'" + d.status + "',country:'" + this.settings.getShortName(d.country) + "'}])\">\n                                    Assign to myself\n                                </md-button>\n                            </td>\n                            <td style=\"background-color:transparent; border: 0px;\">\n                                <type-ahead opp='" + d.opp + "' bpname='" + d.bp + "' status='" + d.status + "' country='" + this.settings.getShortName(d.country) + "' reassign=\"false\"/>\n                            </td>\n                        </tr>\n                        <tr ng-if=\"vm.isSubmitting\">\n                            <td style=\"background-color:transparent; border: 0px;\">\n                                <span class='ibm-h1' ng-if=\"vm.isSubmitting\">\n                                    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n                                </span>\n                            </td>\n                        </tr>\n                    </table>").contents())(this.$scope);
        }
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.buildColumns_Error = function () {
        var _this = this;
        var that = this;
        return [
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Select')
                .notSortable()
                .renderWith(function (data, type, full, meta) {
                return "<input type=\"checkbox\"\n                                ng-class=\"{'hide-dt-column': !vm.isMassAssignmentToggled}\"\n                                ng-model=\"vm.checkBoxModel['" + data.opp + "']\"/>";
            })
                .withOption('name', 'assign-col')
                .withOption('searchable', false),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Assign')
                .notSortable()
                .renderWith(function (data) {
                if (data.substatus !== 'Unassigned' && !_this.isAdminUser()) {
                    return "<span>\n                                <md-icon md-svg-icon=\"forbidden\"/>\n                            </span>";
                }
                else {
                    return "<span>\n                                <md-icon class=\"expand\" md-svg-icon=\"expand\" ng-click=\"vm.expand()\"/>\n                            </span>\n                            <span>\n                                <md-icon class=\"collapse ng-hide\" md-svg-icon=\"collapse\" ng-click=\"vm.expand()\"/>\n                            </span>";
                }
            })
                .withOption('className', 'details-control')
                .withOption('searchable', false),
            this.DTColumnBuilder.newColumn('ver').withTitle('Version')
                .withOption('name', 'ver')
                .renderWith(this.getVersionLabel)
                .notSortable(),
            this.DTColumnBuilder.newColumn('opp').withTitle('Opportunity')
                .withOption('name', 'opp').renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('opp_group_id').withTitle('Opportunity Group ID')
                .withOption('name', 'opp_group_id'),
            this.DTColumnBuilder.newColumn('svistat')
                .withTitle('MySA Status').withOption('name', 'svistat'),
            this.DTColumnBuilder.newColumn('bp').withOption('name', 'bp')
                .withTitle('BP Name'),
            this.DTColumnBuilder.newColumn('country')
                .withTitle('Country').withOption('name', 'country'),
            this.DTColumnBuilder.newColumn('acnt').withOption('name', 'acnt')
                .withTitle('Account Name'),
            this.DTColumnBuilder.newColumn('sodate').withOption('name', 'sodate')
                .withTitle('SO date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); })
                .withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('payment_date').withOption('name', 'payment_date')
                .withTitle('Payment request date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); })
                .withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('status').withTitle('Status')
                .withOption('name', 'status'),
            this.DTColumnBuilder.newColumn('substatus').withOption('name', 'substatus')
                .withTitle('Sub Status'),
            this.DTColumnBuilder.newColumn('errorStat')
                .withTitle('No. of Errors').renderWith(this.errorDisplay).withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('GOE').withOption('name', 'GOE')
                .withTitle('Government Flag').withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('dispute_itrtype').withOption('name', 'dispute_itrtype')
                .withTitle('Credit/ debit flag').withOption('searchable', false).notSortable(),
            this.DTColumnBuilder.newColumn('aging').withOption('name', 'aging')
                .withTitle('Aging').withOption('searchable', false).notSortable(),
            // this.DTColumnBuilder.newColumn('errQty')
            //   .withTitle('No. of Errors'),//.renderWith(this.errorDisplay),
            this.DTColumnBuilder.newColumn('owner')
                .withOption('name', 'owner').withTitle('Owner').renderWith(function (data) {
                if (data.userid !== null) {
                    /*return `<span>
                        <img class="table-img-circle" ng-src="//faces.tap.ibm.com/imagesrv/${data.userid}.jpg?s=75"/>
                        <span class="ibm-center ibm-regular">${data.name}</span>
                    </span>`;*/
                    return "<span>\n                            <img class=\"table-img-circle\" ng-src=\"" + _this.getAvatar(data.userid) + "\"/>\n                            <span class=\"ibm-center ibm-regular\">" + data.name + "</span>\n                        </span>";
                }
                else {
                    return "<span>N/A</span>";
                }
            }),
        ];
    };
    QueueController.prototype.getAvatar = function (email) {
        return this.DTS.getAvatar(email, 115);
    };
    QueueController.prototype.getDateFormat = function (d) {
        if (!d) {
            return '';
        }
        else if (d.search('/') > -1) {
            return 'MM/DD/YYYY';
        }
        else if (d.search('-') > -1) {
            return 'YYYY-MM-DD';
        }
        else if (d.substring(2, 3) === '.') {
            return 'DD.MM.YYYY';
        }
        else {
            return 'YYYYMMDD';
        }
    };
    QueueController.prototype.getFinePrintedData = function (d) {
        // console.log('finePrintedData before: ' + d + ' type: ' + typeof d + 'is not number: ' + Number.isNaN(Number(d)));
        if (!d || d === 'N/A' || (typeof d !== 'string' && typeof d !== 'number')) {
            return 'N/A';
        }
        var mom = Number.isNaN(Number(d))
            ? this.moment(d, this.getDateFormat(String(d)))
            : this.moment.utc(Number(d));
        // console.log('finePrintedData after: ' + mom.format('YYYY/MM/DD'));
        return mom.format('YYYY/MM/DD');
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.buildColumns = function () {
        var _this = this;
        var that = this;
        var columns = [
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Select')
                .notSortable()
                .renderWith(function (data, type, full, meta) {
                return "<input type=\"checkbox\"\n                                ng-class=\"{'hide-dt-column': !vm.isMassAssignmentToggled}\"\n                                ng-model=\"vm.checkBoxModel['" + data.opp + "']\"/>";
            })
                .withOption('name', 'assign-col')
                .withOption('searchable', false),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Assign')
                .notSortable()
                .renderWith(function (data) {
                //If Work Items and user is not System Admin, or If not Work Items and user is not BPSO/Non-BPSO Admin...Block Assignment drop-down
                if ((that.queryId === 'workitems' && !_this.env.user.access.systemAdmin) || (that.queryId !== 'workitems' && !_this.isAdminUser())) {
                    return "<span>\n                                    <md-icon md-svg-icon=\"forbidden\"/>\n                                </span>";
                }
                else {
                    return "<span>\n                                    <md-icon class=\"expand\" md-svg-icon=\"expand\" ng-click=\"vm.expand()\"/>\n                                </span>\n                                <span>\n                                    <md-icon class=\"collapse ng-hide\" md-svg-icon=\"collapse\" ng-click=\"vm.expand()\"/>\n                                </span>";
                }
            })
                .withOption('className', 'details-control')
                .withOption('searchable', false),
            this.DTColumnBuilder.newColumn('ver').withTitle('Version')
                .withOption('name', 'ver')
                .renderWith(this.getVersionLabel)
                .notSortable(),
            this.DTColumnBuilder.newColumn('opp').withTitle('Opportunity')
                .withOption('name', 'opp').renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('opp_group_id').withTitle('Opportunity Group ID')
                .withOption('name', 'opp_group_id'),
            this.DTColumnBuilder.newColumn('svistat')
                .withOption('name', 'svistat').withTitle('MySA Status'),
            this.DTColumnBuilder.newColumn('bp').withOption('name', 'bp').withTitle('BP Name'),
            this.DTColumnBuilder.newColumn('country')
                .withOption('name', 'country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('acnt').withOption('name', 'acnt')
                .withTitle('Account Name'),
            this.DTColumnBuilder.newColumn('svisubmitdate')
                .withOption('name', 'svisubmitdate').withTitle('CVR Submit Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('decisiondate').withOption('name', 'decisiondate')
                .withTitle('Decision Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); })
        ];
        if (this.queryId === 'workitems' || this.queryId === 'myqueue' || this.queryId === 'teamqueue') {
            columns.push(this.DTColumnBuilder.newColumn('soNumber')
                .withOption('name', 'soNumber')
                .withTitle('SO number')
                .withOption('searchable', false).notSortable());
        }
        if (this.queryId === 'myqueue' || this.queryId === 'teamqueue' || this.queryId === 'workitems') {
            columns.push(this.DTColumnBuilder.newColumn('payment_date')
                .withOption('name', 'payment_date')
                .withTitle('Payment request date').withOption('searchable', false).notSortable()
                .renderWith(function (d) { return _this.getFinePrintedData(d); }));
        }
        columns.push(this.DTColumnBuilder.newColumn('status').withOption('name', 'status').withTitle('Status'));
        columns.push(this.DTColumnBuilder.newColumn('substatus')
            .withOption('name', 'substatus').withTitle('Sub Status'));
        columns.push(this.DTColumnBuilder.newColumn('created').withOption('name', 'created')
            .withOption('searchable', false)
            .notSortable().notVisible());
        columns.push(this.DTColumnBuilder.newColumn('acctstate').withOption('name', 'acctstate')
            .withTitle('State ').renderWith(function (data, type, full) {
            if (data.state !== null && data.country === 'USA') {
                return "<span class=\"ibm-center ibm-regular\" title=\"US State\">" + data.state + "</span>";
            }
            else {
                return "<span class =\"ibm-h2\">\n                                <md-icon md-svg-src=\"/public/icons/ic_highlight_off_black_24px.svg\" title=\"US state not found\" aria-label=\"USstate\"> </md-icon>\n                            </span>";
            }
        }));
        if (this.queryId === 'myqueue' || this.queryId === 'teamqueue' || this.queryId === 'workitems') {
            columns.push(this.DTColumnBuilder.newColumn('dispute_itrtype').withOption('name', 'dispute_itrtype').withTitle('Credit/ Debit flag').withOption('searchable', false).notSortable());
        }
        if (this.queryId === 'unassigned' || this.queryId === 'manualReview' || this.queryId === 'workitems' || this.queryId === 'myqueue' || this.queryId === 'teamqueue') {
            columns.push(this.DTColumnBuilder.newColumn('aging').withOption('name', 'aging').withTitle('Aging').withOption('searchable', false).notSortable());
        }
        if (this.queryId === 'teamqueue' || this.queryId === 'workitems') {
            columns.push(this.DTColumnBuilder.newColumn('owner').withOption('name', 'owner').withTitle('Owner').renderWith(function (data) {
                if (Boolean(data.name)) {
                    return "<span>\n                            <img class=\"table-img-circle\" ng-src=\"" + _this.getAvatar(data.userid) + "\"/>\n                                <span class=\"ibm-center ibm-regular\">" + data.name + "</span>\n                            </span>";
                }
                else {
                    return "<span>N/A</span>";
                }
            }));
        }
        return columns;
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.buildColumnsGeoSpm = function () {
        var _this = this;
        return [
            this.DTColumnBuilder.newColumn('opp').withOption('name', 'opp')
                .withTitle('Opportunity Number')
                .renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('svistat').withOption('name', 'svistat')
                .withTitle('MySA Status'),
            this.DTColumnBuilder.newColumn('bp').withOption('name', 'bp')
                .withTitle('BP Name'),
            this.DTColumnBuilder.newColumn('acnt').withOption('name', 'acnt')
                .withTitle('Account Name'),
            this.DTColumnBuilder.newColumn('country').withOption('name', 'country')
                .withTitle('Account Country'),
            this.DTColumnBuilder.newColumn('acctstate').withOption('name', 'acctstate')
                .withTitle('Account State')
                .renderWith(function (data) {
                if (data.state !== null && data.country === 'USA') {
                    return "<span class=\"ibm-center ibm-regular\" title=\"US State\">" + data.state + "</span>";
                }
                else {
                    return "<span class =\"ibm-h2\">\n                                <md-icon md-svg-src=\"/public/icons/ic_highlight_off_black_24px.svg\" title=\"US state not found\" aria-label=\"USstate\"> </md-icon>\n                            </span>";
                }
            }),
            this.DTColumnBuilder.newColumn('svisubmitdate').withOption('name', 'svisubmitdate')
                .withTitle('Submit Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('sviexpdate').withOption('name', 'sviexpdate')
                .withTitle('Expiration Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('decisiondate').withOption('name', 'decisiondate')
                .withTitle('Decision Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('payment_date').withOption('name', 'payment_date')
                .withTitle('Submit Date for Payment')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
            this.DTColumnBuilder.newColumn('soNumber').withOption('name', 'soNumber')
                .withTitle('Sales Order Number'),
            //.withOption('searchable', true).notSortable(),
            this.DTColumnBuilder.newColumn('ge').withOption('name', 'ge')
                .withTitle('GE flag'),
            this.DTColumnBuilder.newColumn('nc').withOption('name', 'nc')
                .withTitle('New Client')
                .renderWith(function (d) { return (_.isUndefined(d) || d === null) ? '' : Boolean(d); }),
            this.DTColumnBuilder.newColumn('cd').withOption('name', 'cd')
                .withTitle('Customer Designation'),
            this.DTColumnBuilder.newColumn('dcid').withOption('name', 'dcid')
                .withTitle('DCID'),
            this.DTColumnBuilder.newColumn('dbg').withOption('name', 'dbg')
                .withTitle('DBG'),
            this.DTColumnBuilder.newColumn('ncExpDate').withOption('name', 'ncExpDate')
                .withTitle('New Client Expiration Date')
                .renderWith(function (d) { return _this.getFinePrintedData(d); }),
        ];
    };
    QueueController.prototype.linkUrl = function (data, type, full, meta) {
        return '<a class="ibm-ind-link" href="detail/' + data + '/general" ng-click="$event.preventDefault();vm.edit(' + meta.row + ')">' + data + '</a>';
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.actionsHtml = function (data, type, full, meta) {
        if (this.$stateParams.id === 'workitems') {
            return "<span>\n                        <md-icon md-svg-icon=\"forbidden\"/>\n                    </span>";
        }
        else {
            return "<span>\n                        <md-icon class=\"expand\" md-svg-icon=\"expand\" ng-click=\"vm.expand()\"/>\n                    </span>\n                    <span>\n                        <md-icon class=\"collapse ng-hide\" md-svg-icon=\"collapse\" ng-click=\"vm.expand()\"/>\n                    </span>";
        }
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.errorDisplay = function (data, type, full, meta) {
        var display = '';
        for (var i = 0; i < data.length; i++) {
            if (i > 0) {
                display += '\n';
            }
            display += '#' + (i + 1) + ' - Type: ' + data[i].type + '  - Details: ' + data[i].details;
        }
        return "<p style=\"font-size: inherit\" class=\"ibm-textcolor-blue-40\" title=\"" + display + "\">" + data.length + "<sup style=\"margin-left: 3px\" class=\"errComments\">DETAILS</sup></p> ";
    };
    QueueController.prototype.changemade = function (index) {
        $('#table_filter input:first').keyup();
    };
    // tslint:disable-next-line: member-ordering
    QueueController.prototype.assign = function (opp, owner) {
        if (opp === undefined) {
            opp = [];
            for (var prop in this.checkBoxModel) {
                if (this.checkBoxModel.hasOwnProperty(prop)) {
                    if (this.checkBoxModel[prop]) {
                        var data = {};
                        data.opp = prop;
                        for (var i = 0; i < this.dtInstance.DataTable.rows().data().length; i++) {
                            if (this.dtInstance.DataTable.rows().data()[i].opp === prop &&
                                this.dtInstance.DataTable.rows().data()[i].substatus === 'Unassigned') {
                                data.bpname = this.dtInstance.DataTable.rows().data()[i].bp;
                                data.status = this.dtInstance.DataTable.rows().data()[i].status; //Status added to determine if Assigning at REceived or Validation
                                data.mass = true; //Indicates mass assignment taking place
                                opp.push(data);
                                break;
                            }
                        }
                    }
                }
            }
        }
        if (owner === undefined) {
            owner = this.env.user.email;
        }
        if ((opp instanceof Array && opp.length !== 0) || !(opp instanceof Array)) {
            this.isSubmitting = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'assignRequests',
                    script: '/queueservice/assign',
                    data: {
                        opps: opp,
                        email: owner,
                        reassign: false,
                        currentUser: this.env.user.email,
                        notifications: this.env.notifications
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    QueueController.prototype.isSelected = function () {
        for (var prop in this.checkBoxModel) {
            if (this.checkBoxModel.hasOwnProperty(prop)) {
                if (this.checkBoxModel[prop]) {
                    return true;
                }
            }
        }
        return false;
    };
    QueueController.prototype.reAssign = function (newOwner) {
        this.isSubmitting = true;
        var opp = [];
        for (var prop in this.checkBoxModel) {
            if (this.checkBoxModel.hasOwnProperty(prop)) {
                if (this.checkBoxModel[prop]) {
                    var data = {};
                    data.opp = prop;
                    for (var i = 0; i < this.dtInstance.DataTable.rows().data().length; i++) {
                        if (this.dtInstance.DataTable.rows().data()[i].opp === prop) {
                            data.bpname = this.dtInstance.DataTable.rows().data()[i].bp;
                            break;
                        }
                    }
                    opp.push(data);
                }
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'assignRequests',
                script: '/queueservice/assign',
                data: {
                    opps: opp,
                    email: newOwner,
                    reassign: true,
                    currentUser: this.env.user.email,
                    notifications: this.env.notifications //User
                },
                token: this.env.user.token
            }
        });
    };
    QueueController.prototype.edit = function (index) {
        var rowData = this.dtInstance.DataTable.row(index).data();
        this.moveToOpp(rowData);
    };
    QueueController.prototype.moveToOpp = function (data) {
        if (this.queueLabel === 'Unassigned Queue') {
            this.$state.go('preview', {
                id: data.opp
            });
        }
        else {
            this.$state.go('detail.general', {
                id: data.opp
            });
        }
    };
    QueueController.prototype.toggleMassAssignment = function () {
        this.isMassAssignmentToggled = !this.isMassAssignmentToggled;
    };
    QueueController.prototype.filterDetails = function () {
        var _this = this;
        this.env.topics.imtFilterValues = this.settings.country_list;
        this.filters.iots = this.settings.iot_list;
        this.filters.imts = this.settings.imt_list;
        this.filters.countries = this.settings.getCountryList();
        if (!Array.isArray(this.filters.imts)) {
            this.filters.imts = [];
        }
        if (!Array.isArray(this.filters.iots)) {
            this.filters.iots = [];
        }
        if (!Array.isArray(this.filters.countries)) {
            this.filters.countries = [];
        }
        if (!Array.isArray(this.env.topics.imtFilterValues)) {
            this.env.topics.imtFilterValues = [];
        }
        this.filters.imts.sort();
        this.filters.iots.sort();
        this.filters.countries.sort();
        this.env.topics.imtFilterValues.forEach(function (value) {
            if (value.ic === 'IOT') {
                if (!_.includes(_this.filters.iots, value.imt)) {
                    _this.filters.iots.push(value.imt);
                }
            }
            else if (value.ic === 'IMT') {
                if (!_.includes(_this.filters.imts, value.imt_name)) {
                    _this.filters.imts.push(value.imt_name);
                }
            }
            else {
                if (!_.includes(_this.filters.countries, value.country)) {
                    _this.filters.countries.push(value.country);
                }
            }
        });
        this.filters.sviStatuses = this.settings.svistatuses;
        this.filters.statuses = this.settings.statuses;
        this.filters.subStatuses = this.settings.substatuses;
        this.filters.errorTypes = [{ t: 'Payment Errors', n: 'Payment Error' }, { t: 'WOV Errors', n: 'wovError' }, { t: 'Validation Errors', n: 'Validation Error' }, { t: 'Calculation Errors', n: 'calcError' }, { t: 'Auto GOE Errors', n: 'Auto GOE' }];
        this.showFilterBtn = true;
    };
    QueueController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            if (this.filterIots.length > 0) {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.imts, value.imt_name)) {
                            _this.filters.imts.push(value.imt_name);
                        }
                    }
                    else if (value.ic === 'Country') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        _this.filters.imts.push(value.imt_name);
                    }
                    else if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
            this.filters.imts.sort();
            this.filters.countries.sort();
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            if (this.filterImts.length > 0) {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'Country') {
                        if (_.includes(_this.filterImts, value.imt_name) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
        }
    };
    QueueController.prototype.getTeamView = function () {
        this.$state.go('team', {
            id: this.env.user.email
        });
    };
    QueueController.prototype.toggleFilter = function () {
        if (this.isFilterToggled) {
            this.applyFilter();
        }
        this.isFilterToggled = !this.isFilterToggled;
    };
    QueueController.prototype.applyActiveInactive = function (value) {
        this.activeInactive = value;
        this.applyFilter();
    };
    QueueController.prototype.setLastFilter = function () {
        var _this = this;
        //Update the User Profile's lastFilter object in session
        var lf = {};
        var filters = ['vapFilter', 'verFilter', 'goeFilter', 'filterErrors', 'filterSubStatuses', 'filterStatuses', 'filterOwners',
            'filterCountries', 'filterSviStatuses', 'filterTeams', 'filterImts', 'filterIots', 'selectedStates'];
        angular.forEach(filters, function (filter) {
            lf[filter] = _this[filter];
        });
        this.settings.up.lastFilter = lf;
    };
    QueueController.prototype.applyFilter = function () {
        if (this.filterSubStatuses.length ||
            this.filterTeams.length ||
            this.filterStatuses.length ||
            this.filterCountries.length ||
            this.filterOwners.length ||
            this.filterSviStatuses.length ||
            this.filterImts.length ||
            this.filterIots.length ||
            (angular.isDefined(this.filterErrors) && this.filterErrors.length) ||
            angular.isDefined(this.goeFilter) ||
            angular.isDefined(this.vapFilter) ||
            angular.isDefined(this.verFilter)) {
            this.isFilterSet = true;
        }
        else {
            this.isFilterSet = false;
        }
        this.setLastFilter(); //Set User Profile 'last filter' for session
        this.dtInstance.DataTable.ajax.reload();
    };
    QueueController.prototype.clearFilter = function () {
        this.isFilterSet = false;
        this.vapFilter = undefined; //was false
        this.verFilter = undefined;
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.activeInactive = 'active';
        this.filterOwners = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.selectedStates = [];
        this.filterTeams = [];
        this.filterImts = [];
        this.filterIots = [];
        this.filterErrors = [];
        this.filterPayFreq = [];
        this.goeFilter = undefined;
        this.dtInstance.DataTable.ajax.reload();
        delete this.settings.up.lastFilter; //Lose the last filter, too
    };
    QueueController.prototype.toggleInvite = function () {
        if (this.isInviteToggled) {
            this.applyFilter();
        }
        this.isInviteToggled = !this.isInviteToggled;
    };
    QueueController.prototype.toggleDownload = function () {
        this.isDownloading = true;
    };
    QueueController.prototype.toggleSetAsideDownload = function () {
        this.waitForReport = true;
        this.oncePressed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'setAsideRepCSV',
                script: 'reporting/report-set-aside',
                user: this.env.user,
                filters: {
                    freq: this.filterPayFreq,
                    countryFilter: this.filterCountries,
                    iotFilter: this.filterIots,
                    imtFilter: this.filterImts,
                    columnFilter: this.getSearchColumnFilter(),
                    searchFilter: this.getSearchFilterValue()
                }
            }
        });
    };
    // TODO - combine this logic (UI part) with 'paymentFunctions.getSetAsideData()' (server side)
    QueueController.prototype.getSearchColumnFilter = function () {
        var result = {};
        var col;
        var colName;
        var colValue;
        var columns = this.dtColumns;
        for (var columnId in columns) {
            col = columns[columnId];
            colValue = col.columnSearch;
            if (colValue && colValue.trim() !== '') {
                if (col.sTitle === 'opptyNum' || col.name === 'opptyNum') {
                    colName = 'opptyNum';
                }
                else {
                    colName = col.mData.replace('doc.', '');
                    if (colName.trim() === '') {
                        colName = 'dateFreq';
                    }
                }
                result[colName] = colValue;
            }
        }
        return result;
    };
    QueueController.prototype.getSearchFilterValue = function () {
        //TODO - make it better
        return $('#table_filter input:first').val();
    };
    QueueController.prototype.saveFilter = function () {
        var filterFound = false;
        if (typeof this.userFilters !== 'undefined') {
            for (var i = 0; i < this.userFilters.length; i++) {
                if (this.userFilters[i].name === this.newSearch) {
                    filterFound = true;
                    this.userFilters[i].vapFilter = this.vapFilter;
                    this.userFilters[i].verFilter = this.verFilter;
                    this.userFilters[i].goeFilter = this.goeFilter;
                    this.userFilters[i].filterSubStatuses = this.filterSubStatuses;
                    this.userFilters[i].filterStatuses = this.filterStatuses;
                    this.userFilters[i].selectedStates = this.selectedStates;
                    this.userFilters[i].filterOwners = this.filterOwners;
                    this.userFilters[i].filterCountries = this.filterCountries;
                    this.userFilters[i].filterSviStatuses = this.filterSviStatuses;
                    this.userFilters[i].filterTeams = this.filterTeams;
                    this.userFilters[i].filterImts = this.filterImts;
                    this.userFilters[i].filterIots = this.filterIots;
                    this.userFilters[i].filterErrors = this.filterErrors;
                    break;
                }
            }
        }
        if (!filterFound) {
            var saveSearchObj = {};
            saveSearchObj.name = this.newSearch;
            saveSearchObj.vapFilter = this.vapFilter;
            saveSearchObj.verFilter = this.verFilter;
            saveSearchObj.filterSubStatuses = this.filterSubStatuses;
            saveSearchObj.filterStatuses = this.filterStatuses;
            saveSearchObj.filterOwners = this.filterOwners;
            saveSearchObj.selectedStates = this.selectedStates;
            saveSearchObj.filterCountries = this.filterCountries;
            saveSearchObj.filterSviStatuses = this.filterSviStatuses;
            saveSearchObj.filterTeams = this.filterTeams;
            saveSearchObj.filterImts = this.filterImts;
            saveSearchObj.filterIots = this.filterIots;
            saveSearchObj.filterErrors = this.filterErrors;
            saveSearchObj.goeFilter = this.goeFilter;
            if (typeof this.userFilters !== 'undefined') {
                this.userFilters.push(saveSearchObj);
            }
            else {
                this.userFilters = [saveSearchObj];
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'SaveFilter',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                data: this.userFilters
            }
        });
    };
    QueueController.prototype.changeSavedFilter = function (filter) {
        this.currFilter = filter;
        this.filterIots = filter.filterIots;
        this.filterImts = filter.filterImts;
        this.filterCountries = filter.filterCountries;
        this.selectedStates = filter.selectedStates;
        this.filterSviStatuses = filter.filterSviStatuses;
        this.filterStatuses = filter.filterStatuses;
        this.filterSubStatuses = filter.filterSubStatuses;
        this.filterOwners = filter.filterOwners;
        this.filterTeams = filter.filterTeams;
        this.filterErrors = filter.filterErrors;
        this.vapFilter = filter.vapFilter;
        this.verFilter = filter.verFilter;
        this.goeFilter = filter.goeFilter;
    };
    QueueController.prototype.deleteProfile = function (profile) {
        //console.info(profile);
        this.allowed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteProfile',
                script: '/queueservice/filterprofiles',
                user: this.env.user.email,
                data: profile,
                token: this.env.user.token
            }
        });
    };
    //setaside queue
    QueueController.prototype.buildColumnsSetAside = function () {
        var that = this;
        return [this.DTColumnBuilder.newColumn('doc.ceid')
                .withTitle('CEID')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.bpName')
                .withTitle('BP Name')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.bpCountry')
                .withTitle('BP Country')
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.docCountry')
                .withTitle('Opportunity Country')
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Opportunity number')
                .withOption('width', '100%')
                .renderWith(function (data, type, full, meta) {
                var oneOpprty = that.items[meta.row].doc.docs;
                var opptyList = '';
                oneOpprty.forEach(function (el, i) {
                    opptyList += i === oneOpprty.length - 1 ? el.id : el.id + '<br>';
                });
                return opptyList;
            })
                .notSortable()
                .withOption('name', 'opptyNum'),
            this.DTColumnBuilder.newColumn('doc.payDateNFreq')
                .withTitle('Payment Date / Frequency')
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('Bonus Amount')
                .withOption('searchable', false)
                .renderWith(function (data, type, full, meta) {
                return full.doc.amount + " " + full.doc.currency;
            })
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.docs.length')
                .withTitle('Documents')
                .withOption('searchable', false)
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.invsRequested')
                .withTitle('Requested')
                .withOption('searchable', false)
                .notSortable(),
            this.DTColumnBuilder.newColumn('doc.invsReceived')
                .withTitle('Received')
                .withOption('searchable', false)
                .notSortable(),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('')
                .notSortable()
                .withOption('searchable', false)
                .renderWith(this.buttonDetails)
                .withOption('className', 'details-control'),
            this.DTColumnBuilder.newColumn(null)
                .withTitle('')
                .withOption('searchable', false)
                .notSortable()
                .renderWith(this.buttonPaid)
                .withOption('className', 'details-control'),
        ];
    };
    QueueController.prototype.buttonDetails = function (data, type, full, meta) {
        return "<md-button class=\"md-raised md-primary\" ng-click=\"vm.getDetails('" + meta.row + "')\" ng-disabled=\"vm.processing\">Details</md-button>";
    };
    QueueController.prototype.buttonPaid = function (data, type, full, meta) {
        return "<md-button class=\"md-raised md-primary\" ng-click=\"vm.setPaid('" + meta.row + "')\" ng-disabled=\"vm.processing\">Paid</md-button>";
    };
    QueueController.prototype.setPaid = function (rowId) {
        var _this = this;
        if (this.processing) {
            return;
        }
        // const oneItem = JSON.parse(rowId);
        var items = {
            docs: this.items[rowId].doc.docs.map(function (doc) {
                if (doc.invoice_flags && doc.invoice_flags.requested && doc.invoice_flags.received) {
                    return {
                        doc: doc.id,
                        value: true
                    };
                }
            })
                .filter(function (item) {
                return item !== undefined;
            })
        };
        if (items.docs.length === 0) {
            var items_1 = {
                icon: 'ERROR',
                message: 'No documents with invoice received flag.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_1, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.Dialog.updateValidForm(undefined, items, 'setAside-documents_select.html').then(function (dResult) {
            _this.processing = true;
            var docs = [];
            dResult.docs.forEach(function (doc) {
                if (doc.value === true) {
                    docs.push(doc.doc);
                }
            });
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'setPaid',
                    data: {
                        docs: docs,
                        item: _this.items[rowId].doc
                    },
                    script: 'detail/payment/v1/payment',
                    email: _this.env.user.email,
                    token: _this.env.user.token
                }
            });
        });
    };
    QueueController.prototype.viewRecord = function (doc_id) {
        this.$state.go('detail.payment', {
            id: doc_id.substring(4)
        });
    };
    QueueController.prototype.getDetails = function (rowId) {
        var _this = this;
        if (this.processing) {
            return;
        }
        console.log(rowId);
        //const oneItem = JSON.parse(rowId);
        var items = {
            item: this.items[rowId],
            select: function (index) {
                _this.Dialog.$mdDialog.cancel();
                _this.viewRecord(_this.items[rowId].doc.docs[index].id); //this.items[rowId].docs[index].id);
            }
        };
        if (items.item.doc.docs.length === 0) {
            var items_2 = {
                icon: 'ERROR',
                message: 'No documents in this bucket.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_2, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.Dialog.updateValidForm(undefined, items, 'setAside-details.html').then(function (dResult) {
            return;
        });
    };
    QueueController.prototype.getVersionLabel = function (ver) {
        switch (ver) {
            case 1:
            case 2:
                return 'CVR';
            default:
                return 'SWDR';
        }
    };
    QueueController.$inject = ['$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$rootScope', 'topic', 'moment'];
    return QueueController;
}());
var QueueComponent = (function () {
    function QueueComponent() {
        this.templateUrl = 'queue.html';
        this.controllerAs = 'vm';
        this.controller = QueueController;
    }
    return QueueComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('collapse', '/public/icons/ic_expand_less_black_18px.svg')
        .icon('filter', '/public/icons/ic_filter_list_black_18px.svg')
        .icon('team', '/public/icons/ic_group_black_18px.svg')
        .icon('expand', '/public/icons/ic_expand_more_black_18px.svg')
        .icon('invitation', '/public/icons/ic_insert_invitation_black_18px.svg')
        .icon('download', 'public/icons/ic_cloud_download_black_18px.svg')
        .icon('forbidden', 'public/images/ic_do_not_disturb_alt_black_24px.svg')
        .icon('assignment', 'public/icons/ic_assignment_black_18px.svg');
})
    .component('queueSection', new QueueComponent());

//# sourceMappingURL=queue.component.js.map
